import { generatePath } from 'react-router-dom';
import frontendLog from '../libs/frontendLog';
import { gameConfig } from '../../../shared/gameConfig';
import {
  KEYSTONE_PACE_DEFAULT_TARGET_PERCENTILE,
  KEYSTONE_PACE_MIN_TARGET_PERCENTILE
} from '../../../shared/types/keystonePace';
import { TWowRetailRoutes } from '../../../../../shared/gameConfig/wowretail/routes';

export const namedRoutes = gameConfig.Routes as TWowRetailRoutes;

export function resolveRoutePath(path: string, params?: Object): string {
  try {
    return generatePath(path, params);
  } catch (err) {
    frontendLog.error({ err, path, params }, 'resolveRoutePath failed');
    return '/';
  }
}

//
// Helpers
//
export function getPathToRun(run: any): string {
  return resolveRoutePath(namedRoutes.MythicKeystoneRun, {
    season: run.season,
    id: `${run.keystone_run_id}-${run.mythic_level}-${run.dungeon.slug}`
  });
}

export function getPathToMythicPlusPaceTargets(params: {
  season: string;
  dungeon: string;
  level: number;
  scope: string;
  itemLevel?: number | null;
  percentile?: number | null;
}): string {
  const path = resolveRoutePath(namedRoutes.MythicPlusPaceTargets, {
    season: params.season,
    dungeon: params.dungeon,
    level: params.level,
    scope: params.scope
  });
  const searchParams = new URLSearchParams();
  // The default item level bracket is derived from the loaded dataset's population, so this builder
  // cannot know it; callers already pass null/undefined for the default. Anything supplied here is
  // an explicit selection and is always serialized.
  if (params.itemLevel != null && Number.isFinite(params.itemLevel)) {
    searchParams.set('itemLevel', String(Math.max(1, Math.round(params.itemLevel))));
  }
  if (params.percentile != null && Number.isFinite(params.percentile)) {
    const clamped = Math.max(KEYSTONE_PACE_MIN_TARGET_PERCENTILE, Math.min(100, params.percentile));
    const percentile = Math.round(clamped * 10) / 10;
    if (percentile !== KEYSTONE_PACE_DEFAULT_TARGET_PERCENTILE) {
      searchParams.set('percentile', percentile.toFixed(1));
    }
  }

  const search = searchParams.toString();
  return search ? `${path}?${search}` : path;
}

export function getPathToLoggedRun(run: any): string {
  return resolveRoutePath(namedRoutes.MythicKeystoneLoggedRun, {
    season: run.season,
    id: `${run.logged_run_id}-${run.mythic_level}-${run.dungeon.slug}`
  });
}
